import axios from 'axios'
import {accessSessionTokenKeyName} from 'src/utils/constants'

export type PlatformLimitations = {
  title: {min: number | null; max: number | null; info: string | null}
  description: {min: number | null; max: number | null; info: string | null}
}

const defaultLimitations: PlatformLimitations = {
  title: {min: null, max: null, info: null},
  description: {min: null, max: null, info: null},
}

export const fetchPlatformLimitations = async (
  platformCode: string | null | undefined
): Promise<PlatformLimitations> => {
  if (!platformCode) return defaultLimitations

  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '')
  const token = localStorage.getItem(accessSessionTokenKeyName)

  try {
    const resp = await axios.get(`${apiBase}/available-platform-limitations`, {
      params: {platform: platformCode},
      headers: {
        Accept: 'application/json',
        ...(token ? {Authorization: `Bearer ${token}`} : {}),
      },
    })

    const records = Array.isArray(resp?.data?.data)
      ? resp?.data?.data
      : Array.isArray(resp?.data)
      ? resp?.data
      : []

    const next = {...defaultLimitations}

    records.forEach((item: any) => {
      if (!item?.field_reference) return
      if (item.field_reference === 'TITLE_LIMIT') {
        next.title = {
          min: item?.min_limit ?? null,
          max: item?.max_limit ?? null,
          info: item?.display_info ?? null,
        }
      }
      if (item.field_reference === 'DESC_LIMIT') {
        next.description = {
          min: item?.min_limit ?? null,
          max: item?.max_limit ?? null,
          info: item?.display_info ?? null,
        }
      }
    })

    return next
  } catch (error) {
    return defaultLimitations
  }
}

export default fetchPlatformLimitations
